module.exports = __webpack_public_path__ + "static/media/VID_20170907_180539.fbc087d3.mp4";